import React from 'react';
import './SignupCreator.css';
import { useNavigation } from '../../../shared/utils/useNavigation';

const SignupCreator = () => {
  const navigate = useNavigation();
  const handleGetStarted = () => {
    navigate.toSignup();
  };

  return (
    <div className="signup-creator-cta">
      <div className="cta-card">
        <h3 className="cta-title">Become a Creator</h3>
        <p className="cta-description">The only platform giving creators 100% of their earnings for life.</p>
        <button className="cta-btn" onClick={handleGetStarted}>
          Get Started
        </button>
      </div>
    </div>
  );
};

export default SignupCreator;

